export function getIconIdentityClassName(
  category: string,
  name: string
): string {
  return `slds-icon-${category}-${name.replace(/_/g, '-')}`;
}
